import React from 'react';
import { SkeletonBody } from '@xingternal/skeleton';

import styles from './JobsSkeleton.css';

const Card = () => (
  <div className={styles.card}>
    <SkeletonBody
      amountRows={1}
      variant="primary"
      className={styles.companyName}
    />
    <SkeletonBody amountRows={2} variant="primary" className={styles.title} />
    <span className={styles.cardBottomText}>
      <SkeletonBody
        variant="primary"
        amountRows={1}
        className={styles.description}
      />
    </span>
    <span className={styles.date}>
      <SkeletonBody variant="primary" amountRows={1} />
    </span>
  </div>
);

const JobsSkeleton = () => (
  <div className={styles.cardWrapper}>
    <Card />
    <Card />
    <Card />
  </div>
);

export default JobsSkeleton;
